import Rx from 'rx-lite';
import $ from 'jquery';

export const searchSubject = new Rx.Subject();

/**
 * Returns an RX subject
 * @param  {string} initialTerm           The initial term to search
 * @param  {string} url                   The api endpoint for the search
 * @param  {Object} additionalQueryParams Extra query parameters (like enteid)
 * @param  {Object} fnBefore							What to do before to make the api request
 * @param  {Object} fnAfter							  What to do after the api request
 * @return {Object}                       Contains Rx.Subject
 */
export function searchFactory(initialTerm, url, additionalQueryParams, fnBefore, fnAfter) {
	// make request
	function search({ term = '', page = 0 }) {
		return $.getJSON(url, { term, page, ...additionalQueryParams })
			.promise();
	}
	// creo uno stream dal subject che campiono ogni 200ms passati i quali se il termine di ricerca è cambiato
	// faccio partire la richiesta verso l'API della ricerca
	const searchResponse_ = searchSubject
	.sample(500)
	.distinctUntilChanged()
	// .tap(v => console.log(v))
	.startWith({ term: initialTerm })
	.tap(fnBefore)
	.flatMapLatest(search)
	.tap(fnAfter)
	.retry(4); // with retry logic
	return {
		searchResponse_,
	};
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/services/search.js
 **/